import React from 'react';

import { escapeHtml } from './html';

type AsteriskToken =
  | { type: 'text'; value: string }
  | { type: 'bold'; value: string };

export const parseAsteriskBold = (input: string): AsteriskToken[] => {
  const tokens: AsteriskToken[] = [];
  let i = 0;

  while (i < input.length) {
    const start = input.indexOf('*', i);
    if (start === -1) {
      const tail = input.slice(i);
      if (tail) tokens.push({ type: 'text', value: tail });
      break;
    }

    if (start > i) {
      tokens.push({ type: 'text', value: input.slice(i, start) });
    }

    const end = input.indexOf('*', start + 1);
    if (end === -1) {
      tokens.push({ type: 'text', value: input.slice(start) });
      break;
    }

    const inner = input.slice(start + 1, end);
    if (inner.length === 0) {
      tokens.push({ type: 'text', value: '**' });
    } else {
      tokens.push({ type: 'bold', value: inner });
    }

    i = end + 1;
  }

  return tokens;
};

export const formatAsteriskBoldToHtml = (input: string): string => {
  const tokens = parseAsteriskBold(input);
  return tokens
    .map((t) => {
      if (t.type === 'bold') return `<strong>${escapeHtml(t.value)}</strong>`;
      return escapeHtml(t.value);
    })
    .join('');
};

export const renderAsteriskBold = (input: string): React.ReactNode => {
  const tokens = parseAsteriskBold(input);
  return React.createElement(
    React.Fragment,
    null,
    ...tokens.map((t: AsteriskToken, idx: number) =>
      t.type === 'bold'
        ? React.createElement('strong', { key: idx }, t.value)
        : React.createElement(React.Fragment, { key: idx }, t.value)
    )
  );
};
